export const INTERROGATOR_LIST = 'INTERROGATOR_LIST';
export const INTERROGATOR_LIST_SUCCESS = 'INTERROGATOR_LIST_SUCCESS';
export const INTERROGATOR_LIST_ERROR = 'INTERROGATOR_LIST_ERROR';

export const INTERROGATOR_DETAILS = 'INTERROGATOR_DETAILS';
export const INTERROGATOR_DETAILS_SUCCESS = 'INTERROGATOR_DETAILS_SUCCESS';
export const INTERROGATOR_DETAILS_ERROR = 'INTERROGATOR_DETAILS_ERROR';

export const ADD_INTERROGATOR_DETAILS = 'ADD_INTERROGATOR_DETAILS';
export const ADD_INTERROGATOR_DETAILS_SUCCESS = 'ADD_INTERROGATOR_DETAILS_SUCCESS';
export const ADD_INTERROGATOR_DETAILS_ERROR = 'ADD_INTERROGATOR_DETAILS_ERROR';

export const UPDATE_INTERROGATOR = 'UPDATE_INTERROGATOR';
export const UPDATE_INTERROGATOR_SUCCESS = 'UPDATE_INTERROGATOR_SUCCESS';
export const UPDATE_INTERROGATOR_ERROR = 'UPDATE_INTERROGATOR_ERROR';

export const DELETE_INTERROGATOR = 'DELETE_INTERROGATOR';
export const DELETE_INTERROGATOR_SUCCESS = 'DELETE_INTERROGATOR_SUCCESS';
export const DELETE_INTERROGATOR_ERROR = 'DELETE_INTERROGATOR_ERROR';